import React, { ErrorInfo, ReactNode } from 'react';
import ErrorMsg from './components/common/ErrorMsg';
import errorResponses from './errorResponses';

interface ErrorBoundaryInAppProps {
  children: ReactNode;
}

class ErrorBoundaryInApp extends React.Component<ErrorBoundaryInAppProps> {
  state = { hasError: false, error: '', info: '' };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info });
    console.log({ error, info });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorMsg error={errorResponses.errorBoundaryInApp} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundaryInApp;
